import { render, staticRenderFns } from "./ListView.vue?vue&type=template&id=37724e68&"
import script from "./ListView.vue?vue&type=script&lang=js&"
export * from "./ListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports